// source: mlmbox/type/asset_pair.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var mlmbox_type_asset_pb = require('../../mlmbox/type/asset_pb.js');
goog.object.extend(proto, mlmbox_type_asset_pb);
goog.exportSymbol('proto.mlmbox.type.AssetPair', null, global);
goog.exportSymbol('proto.mlmbox.type.AssetPair.ID', null, global);
goog.exportSymbol('proto.mlmbox.type.AssetPair.ID.Assets', null, global);
goog.exportSymbol('proto.mlmbox.type.AssetPair.ID.UniqueFieldCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.AssetPair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.AssetPair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.AssetPair.displayName = 'proto.mlmbox.type.AssetPair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.AssetPair.ID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.mlmbox.type.AssetPair.ID.oneofGroups_);
};
goog.inherits(proto.mlmbox.type.AssetPair.ID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.AssetPair.ID.displayName = 'proto.mlmbox.type.AssetPair.ID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.AssetPair.ID.Assets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.AssetPair.ID.Assets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.AssetPair.ID.Assets.displayName = 'proto.mlmbox.type.AssetPair.ID.Assets';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.AssetPair.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.AssetPair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.AssetPair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.AssetPair.toObject = function(includeInstance, msg) {
  var f, obj = {
    assetPairId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    assetPairName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sourceAssetId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    targetAssetId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.AssetPair}
 */
proto.mlmbox.type.AssetPair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.AssetPair;
  return proto.mlmbox.type.AssetPair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.AssetPair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.AssetPair}
 */
proto.mlmbox.type.AssetPair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAssetPairId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetPairName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSourceAssetId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTargetAssetId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.AssetPair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.AssetPair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.AssetPair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.AssetPair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetPairId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAssetPairName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSourceAssetId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTargetAssetId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.mlmbox.type.AssetPair.ID.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.mlmbox.type.AssetPair.ID.UniqueFieldCase = {
  UNIQUE_FIELD_NOT_SET: 0,
  ASSET_PAIR_ID: 1,
  ASSET_PAIR_NAME: 2,
  ASSETS: 3
};

/**
 * @return {proto.mlmbox.type.AssetPair.ID.UniqueFieldCase}
 */
proto.mlmbox.type.AssetPair.ID.prototype.getUniqueFieldCase = function() {
  return /** @type {proto.mlmbox.type.AssetPair.ID.UniqueFieldCase} */(jspb.Message.computeOneofCase(this, proto.mlmbox.type.AssetPair.ID.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.AssetPair.ID.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.AssetPair.ID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.AssetPair.ID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.AssetPair.ID.toObject = function(includeInstance, msg) {
  var f, obj = {
    assetPairId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    assetPairName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assets: (f = msg.getAssets()) && proto.mlmbox.type.AssetPair.ID.Assets.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.AssetPair.ID}
 */
proto.mlmbox.type.AssetPair.ID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.AssetPair.ID;
  return proto.mlmbox.type.AssetPair.ID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.AssetPair.ID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.AssetPair.ID}
 */
proto.mlmbox.type.AssetPair.ID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAssetPairId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetPairName(value);
      break;
    case 3:
      var value = new proto.mlmbox.type.AssetPair.ID.Assets;
      reader.readMessage(value,proto.mlmbox.type.AssetPair.ID.Assets.deserializeBinaryFromReader);
      msg.setAssets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.AssetPair.ID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.AssetPair.ID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.AssetPair.ID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.AssetPair.ID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssets();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.mlmbox.type.AssetPair.ID.Assets.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.AssetPair.ID.Assets.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.AssetPair.ID.Assets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.AssetPair.ID.Assets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.AssetPair.ID.Assets.toObject = function(includeInstance, msg) {
  var f, obj = {
    sourceAsset: (f = msg.getSourceAsset()) && mlmbox_type_asset_pb.Asset.ID.toObject(includeInstance, f),
    targetAsset: (f = msg.getTargetAsset()) && mlmbox_type_asset_pb.Asset.ID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.AssetPair.ID.Assets}
 */
proto.mlmbox.type.AssetPair.ID.Assets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.AssetPair.ID.Assets;
  return proto.mlmbox.type.AssetPair.ID.Assets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.AssetPair.ID.Assets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.AssetPair.ID.Assets}
 */
proto.mlmbox.type.AssetPair.ID.Assets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new mlmbox_type_asset_pb.Asset.ID;
      reader.readMessage(value,mlmbox_type_asset_pb.Asset.ID.deserializeBinaryFromReader);
      msg.setSourceAsset(value);
      break;
    case 2:
      var value = new mlmbox_type_asset_pb.Asset.ID;
      reader.readMessage(value,mlmbox_type_asset_pb.Asset.ID.deserializeBinaryFromReader);
      msg.setTargetAsset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.AssetPair.ID.Assets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.AssetPair.ID.Assets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.AssetPair.ID.Assets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.AssetPair.ID.Assets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceAsset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      mlmbox_type_asset_pb.Asset.ID.serializeBinaryToWriter
    );
  }
  f = message.getTargetAsset();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      mlmbox_type_asset_pb.Asset.ID.serializeBinaryToWriter
    );
  }
};


/**
 * optional Asset.ID source_asset = 1;
 * @return {?proto.mlmbox.type.Asset.ID}
 */
proto.mlmbox.type.AssetPair.ID.Assets.prototype.getSourceAsset = function() {
  return /** @type{?proto.mlmbox.type.Asset.ID} */ (
    jspb.Message.getWrapperField(this, mlmbox_type_asset_pb.Asset.ID, 1));
};


/**
 * @param {?proto.mlmbox.type.Asset.ID|undefined} value
 * @return {!proto.mlmbox.type.AssetPair.ID.Assets} returns this
*/
proto.mlmbox.type.AssetPair.ID.Assets.prototype.setSourceAsset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.type.AssetPair.ID.Assets} returns this
 */
proto.mlmbox.type.AssetPair.ID.Assets.prototype.clearSourceAsset = function() {
  return this.setSourceAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.type.AssetPair.ID.Assets.prototype.hasSourceAsset = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Asset.ID target_asset = 2;
 * @return {?proto.mlmbox.type.Asset.ID}
 */
proto.mlmbox.type.AssetPair.ID.Assets.prototype.getTargetAsset = function() {
  return /** @type{?proto.mlmbox.type.Asset.ID} */ (
    jspb.Message.getWrapperField(this, mlmbox_type_asset_pb.Asset.ID, 2));
};


/**
 * @param {?proto.mlmbox.type.Asset.ID|undefined} value
 * @return {!proto.mlmbox.type.AssetPair.ID.Assets} returns this
*/
proto.mlmbox.type.AssetPair.ID.Assets.prototype.setTargetAsset = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.type.AssetPair.ID.Assets} returns this
 */
proto.mlmbox.type.AssetPair.ID.Assets.prototype.clearTargetAsset = function() {
  return this.setTargetAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.type.AssetPair.ID.Assets.prototype.hasTargetAsset = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 asset_pair_id = 1;
 * @return {number}
 */
proto.mlmbox.type.AssetPair.ID.prototype.getAssetPairId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.AssetPair.ID} returns this
 */
proto.mlmbox.type.AssetPair.ID.prototype.setAssetPairId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.mlmbox.type.AssetPair.ID.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.mlmbox.type.AssetPair.ID} returns this
 */
proto.mlmbox.type.AssetPair.ID.prototype.clearAssetPairId = function() {
  return jspb.Message.setOneofField(this, 1, proto.mlmbox.type.AssetPair.ID.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.type.AssetPair.ID.prototype.hasAssetPairId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string asset_pair_name = 2;
 * @return {string}
 */
proto.mlmbox.type.AssetPair.ID.prototype.getAssetPairName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.AssetPair.ID} returns this
 */
proto.mlmbox.type.AssetPair.ID.prototype.setAssetPairName = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.mlmbox.type.AssetPair.ID.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.mlmbox.type.AssetPair.ID} returns this
 */
proto.mlmbox.type.AssetPair.ID.prototype.clearAssetPairName = function() {
  return jspb.Message.setOneofField(this, 2, proto.mlmbox.type.AssetPair.ID.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.type.AssetPair.ID.prototype.hasAssetPairName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Assets assets = 3;
 * @return {?proto.mlmbox.type.AssetPair.ID.Assets}
 */
proto.mlmbox.type.AssetPair.ID.prototype.getAssets = function() {
  return /** @type{?proto.mlmbox.type.AssetPair.ID.Assets} */ (
    jspb.Message.getWrapperField(this, proto.mlmbox.type.AssetPair.ID.Assets, 3));
};


/**
 * @param {?proto.mlmbox.type.AssetPair.ID.Assets|undefined} value
 * @return {!proto.mlmbox.type.AssetPair.ID} returns this
*/
proto.mlmbox.type.AssetPair.ID.prototype.setAssets = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.mlmbox.type.AssetPair.ID.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.type.AssetPair.ID} returns this
 */
proto.mlmbox.type.AssetPair.ID.prototype.clearAssets = function() {
  return this.setAssets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.type.AssetPair.ID.prototype.hasAssets = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 asset_pair_id = 1;
 * @return {number}
 */
proto.mlmbox.type.AssetPair.prototype.getAssetPairId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.AssetPair} returns this
 */
proto.mlmbox.type.AssetPair.prototype.setAssetPairId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string asset_pair_name = 2;
 * @return {string}
 */
proto.mlmbox.type.AssetPair.prototype.getAssetPairName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.AssetPair} returns this
 */
proto.mlmbox.type.AssetPair.prototype.setAssetPairName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 source_asset_id = 3;
 * @return {number}
 */
proto.mlmbox.type.AssetPair.prototype.getSourceAssetId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.AssetPair} returns this
 */
proto.mlmbox.type.AssetPair.prototype.setSourceAssetId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 target_asset_id = 4;
 * @return {number}
 */
proto.mlmbox.type.AssetPair.prototype.getTargetAssetId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.type.AssetPair} returns this
 */
proto.mlmbox.type.AssetPair.prototype.setTargetAssetId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.mlmbox.type);
